import { Injectable } from '@angular/core';
import { ICreateRoomBody, ICreateRoomResponse, IFetchRoomResponse, IMessage, IRoomDetails } from '../models/dashboard.models';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { IUser } from '../models/auth.models';
import { DatePipe } from '@angular/common';

(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  // chatMessages: FirebaseListObservable<any[]>;
  userId: any;
  loggedInUser: IUser | undefined;
  currentUserName: string;
  datepipe: DatePipe = new DatePipe('en-US')

  constructor(private db: AngularFireDatabase,
    private storage: AngularFireStorage,
    private authService: AuthService,
    private http: HttpClient) {
    this.userId = this.authService.getUserID();
    this.loggedInUser = this.authService.user;
  }

  sendMessage(messageText: string, roomId: string, type: string = 'text', fileUrl = null){
    this.userId = this.authService.getUserID();
    this.loggedInUser = this.authService.user;
    
    let body: IMessage = {
      message: messageText,
      userId: this.userId,
      type: type,
      timestamp: this.messageDate(),
    };

    if(fileUrl){
      body.fileUrl = fileUrl;
    }

    this.db.list(roomId).push(body);
  }

  getMessage(roomId: string, chatLength: number): Observable<any>{
    return this.db.list(roomId, (ref:any) => ref.limitToLast(chatLength).orderByKey()).valueChanges();
  }

  getLastMessage(roomId: string): Observable<any>{
    return this.db.list(roomId, (ref:any) => ref.limitToLast(1).orderByKey()).valueChanges();
  }

  getAllMessages(roomId: string): Observable<any>{
    return this.db.list(roomId, (ref:any) => ref.orderByKey()).valueChanges();
  }

  messageDate(){
    let time = new Date();
    time.setHours(time.getHours() + 5);
    time.setMinutes(time.getMinutes() + 30);
    return String(time.toISOString()).slice(0,-1)
  }

  createChatRoom(body: ICreateRoomBody): Observable<ICreateRoomResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}chat/createroom`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.post<ICreateRoomResponse>(url, body, httpOptions);
  }

  fetchChatRooms(): Observable<IFetchRoomResponse>{
    const token = this.authService.token;
    if(token == undefined)
    {
      throw new Error('Token is not present');
    }
    const url = `${environment.serverUrl}chat/getrooms`;
    let httpOptions = {
      headers: new HttpHeaders({ Authorization: token }),
    }
    return this.http.get<IFetchRoomResponse>(url, httpOptions);
  }

  uploadFile(event: any, roomId: string) {
    const file = event.target.files[0];
    const fileName = event.target.files[0].name;
    const filePath = 'Attachment/' + roomId + '/' + fileName;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);
    task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe(url =>{
            this.sendMessage(fileName, roomId, 'attachment', url)
          })
        })
     )
    .subscribe();
  }

  generatePDF(chats: IMessage[], room: IRoomDetails){
    let content: Array<any> = [];
    let otherUserName = (room.mum) ? room.mum.name : room?.midwife?.name;
    this.currentUserName = this.authService.getUserName();
    for(let i=0; i<chats.length; i++)
    {
      if(i == 0 || chats[i].dateConverted != chats[i-1].dateConverted)
      {
        content.push({text: String(this.datepipe.transform(chats[i].timestamp, 'EEE dd MMM, yyyy')),
        margin: [ 0, 10, 0, 20 ], alignment: 'center', decoration: 'underline', style: 'date'})
      }
      content.push({
        columns: [
          {
            width: '22%',
            text: ((chats[i].userId != this.loggedInUser?.userId) ? otherUserName : this.currentUserName) + ':',
            style: (chats[i].userId != this.loggedInUser?.userId) ? 'yourself' : 'myself'
          },
          [
            chats[i].type == 'attachment' ? {
                text: chats[i].message,
                style: (chats[i].userId != this.loggedInUser?.userId) ? 'yourself' : 'myself',
                link: chats[i].fileUrl,
                decoration: 'underline',
                decorationStyle: 'dotted'
              } : {
                text: chats[i].message,
                style: (chats[i].userId != this.loggedInUser?.userId) ? 'yourself' : 'myself',
              },
            {text: String(this.datepipe.transform(chats[i].timestamp, 'h:mm a')), style: 'time', margin: [0,0,0,12]}
          ]
        ],
        columnGap: 10
      })
    }
    const docDefinition  = {
      footer: function (currentPage: any, pageCount: any) {
        return {
          columns: [
            {
              width: '50%',
              text: ''
            },
            {
              width: '50%',
              text: currentPage.toString()
            },
          ]
        };
      },
      background: function (currentPage: any, pageSize: any) {
        return {
        table: {
        widths: [pageSize.width - 30],
        heights: [pageSize.height - 30],
        body: [['']]
        },
        margin: 10
        };
      },
      content: content,
      styles: {
        myself: {
          color: '#FF81BA'
        },
        yourself: {
          color: '#686EC0'
        },
        time:{
          fontSize: 8,
          color: '#A0A0A0'
        },
        date:{
          color: '#412D38'
        }
      }
    }
    pdfMake.createPdf(docDefinition).download('chat.pdf');
  }
}
